import AdjustmentsIcon from '@heroicons/react/outline/esm/AdjustmentsIcon.js'
import CalendarIcon from '@heroicons/react/outline/esm/CalendarIcon.js'
import DotsHorizontalIcon from '@heroicons/react/outline/esm/DotsHorizontalIcon.js'
import ExternalLinkIcon from '@heroicons/react/outline/esm/ExternalLinkIcon.js'
import PlusIcon from '@heroicons/react/outline/esm/PlusIcon.js'

export const getIcon = (iconName: string) => {
  switch (iconName) {
    case 'ExternalLinkIcon':
      return <ExternalLinkIcon />
    case 'PlusIcon':
      return <PlusIcon />
    case 'DotsHorizontalIcon':
      return <DotsHorizontalIcon />
    case 'AdjustmentsIcon':
      return <AdjustmentsIcon />
    case 'Calendar':
      return <CalendarIcon />
    default:
      return null
  }
}
